<script setup lang="ts">
import { computed } from 'vue'
import Icon from './Icon.vue'
import ScrollAnimate from './ScrollAnimate.vue'
import { useI18n } from '../composables/useI18n'

interface ComponentItem {
  icon: string
  title: string
  subtitle: string
  description: string
}

const { t } = useI18n()

const items = computed<ComponentItem[]>(() => t('components.items') as ComponentItem[])
</script>

<template>
  <section id="components" class="py-20 bg-base-100">
    <div class="max-w-6xl mx-auto px-4">
      <ScrollAnimate as="div" class="text-center max-w-3xl mx-auto mb-12">
        <h2 class="text-3xl md:text-4xl font-bold text-base-content">{{ t('components.title') }}</h2>
        <p class="text-lg text-base-content/70 mt-4">
          {{ t('components.subtitle') }}
        </p>
      </ScrollAnimate>

      <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        <ScrollAnimate
          v-for="(item, index) in items"
          :key="item.title"
          as="div"
          class="card bg-base-200 border border-base-300 hover:shadow-md transition-shadow"
          :delay="index * 0.1"
        >
          <div class="card-body">
            <div class="flex items-center gap-3 mb-3">
              <div class="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center text-primary shrink-0">
                <Icon :name="item.icon" iconClass="w-6 h-6" />
              </div>
              <div>
                <h3 class="card-title text-lg leading-tight">{{ item.title }}</h3>
                <p class="text-xs text-base-content/60">{{ item.subtitle }}</p>
              </div>
            </div>
            <p class="text-base-content/70 text-sm">{{ item.description }}</p>
          </div>
        </ScrollAnimate>
      </div>
    </div>
  </section>
</template>
